import React, { useState } from "react"

import { NotificationManager } from "react-notifications"

import { adminClient as client } from "src/urql-client"

import { gql, useMutation } from "hooks/urql"

import ModalWithProvidedBody from "components/ModalWithProvidedBody"

import { ReferralType } from "."

export type DeleteReferralConfirmationModalProps = {
  referral: ReferralType
  closeModal: VoidFunction
}

const DeleteReferralConfirmationModal: React.FC<
  DeleteReferralConfirmationModalProps
> = ({ referral, closeModal }) => {
  const [error, setError] = useState<string | null>()
  const [, runMutation]: any[] = useMutation(deleteReferralMutation, client)

  if (!referral) return null

  const deleteReferral = () => {
    runMutation({ id: referral.id })
      .then(
        result => {
          const { failures } = result.data.deleteReferral
          if (failures.length > 0) {
            setError(failures[0].message)
          } else {
            closeModal()
            NotificationManager.success("Referral deleted")
          }
        },
        () => setError("Something went wrong")
      )
      .catch(() => setError("Something went wrong"))
  }

  return (
    <ModalWithProvidedBody
      hideTrigger
      modalTitle="Delete Referral"
      isOpen={!!referral}
      closeModal={closeModal}
    >
      <div className="modal-body">
        Are you sure you want to delete this referral for {referral.firstName}?
        If you sent them a signup link, they will no longer be able to use it.
      </div>
      <div className="modal-footer flex-col">
        {error && <div className="alert alert-danger">{error}</div>}
        <div className="flex w-full justify-between">
          <button onClick={closeModal} className="btn btn-info" type="button">
            Nevermind
          </button>
          <button
            onClick={deleteReferral}
            className="btn btn-danger"
            type="button"
          >
            Yes, Delete
          </button>
        </div>
      </div>
    </ModalWithProvidedBody>
  )
}

const deleteReferralMutation = gql`
  mutation DeleteReferral($id: ID!) {
    deleteReferral(id: $id) {
      failures {
        message
      }
    }
  }
`

export default DeleteReferralConfirmationModal
